import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AddToCartButton from '../../ui_add-to-cart-button/component';
import DeliveryPromise from '../../sec_delivery-promise/component';
import StockCheck from '../../sec_stock-check/component';
import KeepMePosted from '../_keep-me-posted/component';
import { Button } from 'audamatic-ui';
import { getFeature } from '@utils';
import Text from '@text';
import { t } from '@utils/i18n';
import GiftcardAction from '../_primary-actions-B2C/giftcard';

import './styles.scss';

const PrimaryActionsB2B = (props) => {
  const { product, store } = props;
  const { offered, availability, isOnline, fullProductAvailability, isGiftcard } = product;

  const stockCheckFeature = getFeature('stockCheck');
  const showStockCheck = stockCheckFeature.isActive && !!product.stockCheck;

  const [expressOrder, setExpressOrder] = useState(false);

  const setAvailibilityText = (isExpressorder) => {
    setExpressOrder(isExpressorder);
  };
  const availibilityText = expressOrder ? t('expressorder.deliveryPromise') : fullProductAvailability;

  // Render gifcard form if it is a giftcard.
  if (isGiftcard) {
    return (
      <GiftcardAction store={store} product={product} />
    );
  }

  // Offerred 4: Only available in store, not online
  if (offered === 4) {
    return (
      <div className="pdp-cta offered-4">
        <DeliveryPromise offered={offered} textKey="offered.storeOnly.msg.html" showIcon />
        <Button variant="secondary" size="large" onClick={() => window.location.href = '/winkels'}>
          <Text>offered.storeOnly.button</Text>
        </Button>
        <StockCheck store={store} product={product} showIcon />
      </div>
    );
  }

  // Offerec 5: Out of stock, keep me posted
  if (offered === 5) {
    return (
      <div className="pdp-cta offered-other">
        <div className="product-detail-buttons" data-test-id="comp-pdpCtaButtons">
          <KeepMePosted product={product} store={store} />
        </div>
        <StockCheck store={store} product={product} showIcon />
        <div className={showStockCheck ? 'show-border' : ''}>
          {availability && isOnline && (
            <DeliveryPromise offered={offered} text={fullProductAvailability} showIcon />
          )}
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="pdp-primaryActions b2b offered-other">
        <div className="productDetailButtons" data-test-id="comp-pdpCtaButtons">
          <AddToCartButton
            product={product}
            store={store}
            dataTestId="button-addToCart"
            showQuantity={true}
            showOrderlineReference={true}
            showExpressOrder={true}
            toggleExpressOrder={setAvailibilityText}
          />
        </div>
        <StockCheck store={store} product={product} showIcon />
        <div className={showStockCheck ? 'show-border' : ''}>
          {availability && isOnline && (
            <DeliveryPromise offered={offered} text={availibilityText} showIcon />
          )}
        </div>
      </div>
    </div>
  );
};

PrimaryActionsB2B.propTypes = {
  product: PropTypes.object,
  store: PropTypes.object,
};

export default PrimaryActionsB2B;
